<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("notificacao") }}
        </h1>
      </div>
      <div class="col-sm-4 text-md-end text-center">
        <router-link v-slot="{ href, navigate }" :to="'/admin/criaNotificacao/'" custom>
          <a :href="href" class="btn btn-primary float-md-start" @click="navigate">
            <i class="bi bi-plus" /> {{ $t("novaNotificacao") }}
          </a>
        </router-link>
      </div>
    </div>
    <!--
    <NotificacaoForm class="mb-4" media="" :video="false" :active="true" @enviar-notificacao="onEnviarNotificacao" />
    -->
    <NotificacaoTable />
  </div>
</template>

<script>
import NotificacaoTable from './components/NotificacaoTable.vue';

export default {
  components: { NotificacaoTable },
};
</script>
